import { CommonResponseModel, PaymentIdRequest, PaymentsDTO, UploadResponse } from "@project-management-system/shared-models";
import { CommonAxiosService } from "../common-axios-service-prs";

export class PaymentsService extends CommonAxiosService{
    URL = '/payments';

    async createPayment(req: PaymentsDTO): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL +  '/createPayment',req)
    }

    async getAllPaymentsRequests(): Promise<CommonResponseModel> {
        return this.axiosPostCall(this.URL + '/getAllPaymentsRequests')
    }

    async uploadPaymentDocs(file: any): Promise<UploadResponse> {
        return await this.axiosPostCall(this.URL + '/uploadPaymentDocs', file);
      }

    async updatePaymentStatus(req:PaymentIdRequest): Promise<CommonResponseModel> {
        return await this.axiosPostCall(this.URL + '/updatePaymentStatus', req);
      }
}